// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609040512/js/" + chunkId + "." + {"44":"b13117dd","225":"f73fc9a2","481":"02187507","486":"58ebb132","770":"40baaf97"}[chunkId] + ".0.802740969146606.chunk.js";
};